var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.dataQualityForRegionList,
            "header-cell-style": { background: "#f2f2f2", color: "black" },
            "span-method": _vm.arraySpanMethod,
            border: "",
            "max-height": "600",
            "row-key": "id",
            stripe: "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "大区(regiões)",
              "min-width": "150",
              prop: "region",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.region || "--"))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "州 Estado",
              "min-width": "100",
              prop: "state",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.state || "--"))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "下单量(Qtd. dos pedidos)",
              "min-width": "150",
              prop: "totalOrderCount",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(scope.row.totalOrderCount.toLocaleString() || 0)
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "出仓量(Qtd. de saída da encomenda)",
              "min-width": "180",
              prop: "outboundCount",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(scope.row.outboundCount.toLocaleString() || 0)
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "揽收量(Coletas realizadas)",
              "min-width": "150",
              prop: "collectCount",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(scope.row.collectCount.toLocaleString() || 0)
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "揽收率(Porcentagem de coleta)",
              "min-width": "160",
              prop: "collectRate",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          (
                            (parseFloat(scope.row.collectRate) || 0) * 100
                          ).toFixed(2) + "%"
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "准时揽收量(Coletas pontuais)",
              "min-width": "150",
              prop: "collectOnTimeCount",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          scope.row.collectOnTimeCount.toLocaleString() || 0
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "准时揽收率(Porcentagem de coleta pontual)",
              "min-width": "200",
              prop: "collectOnTimeRate",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          (
                            (parseFloat(scope.row.collectOnTimeRate) || 0) * 100
                          ).toFixed(2) + "%"
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "妥投量(Entregas concluídas)",
              "min-width": "150",
              prop: "deliveryCount",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(scope.row.deliveryCount.toLocaleString() || 0)
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "妥投率(Porcentagem de entrega)",
              "min-width": "180",
              prop: "deliveryRate",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          (
                            (parseFloat(scope.row.deliveryRate) || 0) * 100
                          ).toFixed(2) + "%"
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "理应送达量(Qtd. de pacote deve ser entregue)",
              "min-width": "200",
              prop: "shouldDeliveryCount",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          scope.row.shouldDeliveryCount.toLocaleString() || 0
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "准时妥投量(Entregas pontuais)",
              "min-width": "170",
              prop: "deliveryOnTimeCount",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          scope.row.deliveryOnTimeCount.toLocaleString() || 0
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "准时妥投率(Porcentagem de entrega pontual)",
              "min-width": "170",
              prop: "deliveryOnTimeRate",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          (
                            (parseFloat(scope.row.deliveryOnTimeRate) || 0) *
                            100
                          ).toFixed(2) + "%"
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "p90",
              "min-width": "100",
              prop: "P90",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.p90 || 0))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "确认丢失量(Perdas confirmadas)",
              "min-width": "150",
              prop: "lostCount",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(scope.row.lostCount.toLocaleString() || 0)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "丢失率(Porcentagem da perda)",
              "min-width": "180",
              prop: "lostRate",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          ((parseFloat(scope.row.lostRate) || 0) * 100).toFixed(
                            2
                          ) + "%"
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "破损量(Encomendas danificadas)",
              "min-width": "150",
              prop: "damagedCount",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(scope.row.damagedCount.toLocaleString() || 0)
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "破损率(Porcentagem de danos)",
              "min-width": "180",
              prop: "damagedRate",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          (
                            (parseFloat(scope.row.damagedRate) || 0) * 100
                          ).toFixed(2) + "%"
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "虚假签收量(Fake deliveries)",
              "min-width": "180",
              prop: "fakeSignCount",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(scope.row.fakeSignCount.toLocaleString() || 0)
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "虚假签收率(Porcentagem de fake deliveries)",
              "min-width": "200",
              prop: "fakeSignRate",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          (
                            (parseFloat(scope.row.fakeSignRate) || 0) * 100
                          ).toFixed(2) + "%"
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label:
                "轨迹断更新20天量(Rastreamento sem atualização há 20 dias)",
              "min-width": "200",
              prop: "trackBreakCount",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(scope.row.trackBreakCount.toLocaleString() || 0)
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "超时效未闭环量(Casos fora do prazo não concluídos)",
              "min-width": "200",
              prop: "timeoutUnclosedCount",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          scope.row.timeoutUnclosedCount.toLocaleString() || 0
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "轨迹完整率(Rastreamentos completos)",
              "min-width": "200",
              prop: "trackIntactRate",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          (
                            (parseFloat(scope.row.trackIntactRate) || 0) * 100
                          ).toFixed(2) + "%"
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label:
                "轨迹签收推送率(Porcentagem de envio de rastreio de assinatura)",
              "min-width": "200",
              prop: "trackSignPushRate",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          (
                            (parseFloat(scope.row.trackSignPushRate) || 0) * 100
                          ).toFixed(2) + "%"
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label:
                "轨迹签收推送准时率(Porcentagem de pontualidade do envio de rastreio de assinatura)",
              "min-width": "250",
              prop: "trackSignPushOnTimeRate",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          (
                            (parseFloat(scope.row.trackSignPushOnTimeRate) ||
                              0) * 100
                          ).toFixed(2) + "%"
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "签收pdd推送率(de impulso de assinatura PDD)",
              "min-width": "200",
              prop: "signPodPushRate",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          (
                            (parseFloat(scope.row.signPodPushRate) || 0) * 100
                          ).toFixed(2) + "%"
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }